var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: "销售订单",
            visible: _vm.show,
            size: "90%",
            "before-close": _vm.handleClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                disabled: _vm.type == "查看" || _vm.isRejectTo,
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-card",
                { attrs: { header: "基础信息" } },
                [
                  _c(
                    "el-row",
                    { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "销售订单号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.sn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sn", $$v)
                                  },
                                  expression: "form.sn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SAP销售单号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.sapOrderSn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sapOrderSn", $$v)
                                  },
                                  expression: "form.sapOrderSn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据类型", prop: "salesCode" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.changeSalesType },
                                  model: {
                                    value: _vm.form.salesCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "salesCode", $$v)
                                    },
                                    expression: "form.salesCode",
                                  },
                                },
                                _vm._l(_vm.salesTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "销售组织",
                                prop: "salesOrganizationId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.isDisabled },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getOptionOrganization(
                                        _vm.form.salesOrganizationId
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.form.salesOrganizationId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "salesOrganizationId",
                                        $$v
                                      )
                                    },
                                    expression: "form.salesOrganizationId",
                                  },
                                },
                                _vm._l(
                                  _vm.salesOrganizationOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "分销渠道",
                                prop: "channelOfDistributionId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.isDisabled },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getProductTeamOption(
                                        _vm.form.channelOfDistributionId
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.form.channelOfDistributionId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "channelOfDistributionId",
                                        $$v
                                      )
                                    },
                                    expression: "form.channelOfDistributionId",
                                  },
                                },
                                _vm._l(
                                  _vm.channelDistributioOption,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "产品组", prop: "productTeamId" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.isDisabled },
                                  model: {
                                    value: _vm.form.productTeamId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "productTeamId", $$v)
                                    },
                                    expression: "form.productTeamId",
                                  },
                                },
                                _vm._l(_vm.productTeamOption, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "业务类型",
                                prop: "businessTypeId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.form.businessTypeId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "businessTypeId", $$v)
                                    },
                                    expression: "form.businessTypeId",
                                  },
                                },
                                _vm._l(
                                  _vm.businessTypeOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "售达方",
                                prop: "soldToPartyName",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    readonly: "",
                                    placeholder: "请点击图标选择",
                                  },
                                  model: {
                                    value: _vm.form.soldToPartyName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "soldToPartyName", $$v)
                                    },
                                    expression: "form.soldToPartyName",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectSoldToParty },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "送达方",
                                prop: "deliverySideName",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    readonly: "",
                                    placeholder: "请点击图标选择",
                                  },
                                  model: {
                                    value: _vm.form.deliverySideName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "deliverySideName",
                                        $$v
                                      )
                                    },
                                    expression: "form.deliverySideName",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectDeliverySide },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据状态", prop: "status" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.statusArr[_vm.form.status],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.statusArr,
                                      _vm.form.status,
                                      $$v
                                    )
                                  },
                                  expression: "statusArr[form.status]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "交货工厂", prop: "factoryId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.form.factoryId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "factoryId", $$v)
                                    },
                                    expression: "form.factoryId",
                                  },
                                },
                                _vm._l(_vm.factoryOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "中间公司",
                                prop: "middleCompanyId",
                                rules:
                                  _vm.form.isVatRetreat == 1
                                    ? [
                                        {
                                          required: true,
                                          message: "请选择中间公司",
                                          trigger: "change",
                                        },
                                      ]
                                    : [],
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    readonly: "",
                                    placeholder: "请点击图标选择",
                                  },
                                  model: {
                                    value: _vm.form.middleCompanyName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "middleCompanyName",
                                        $$v
                                      )
                                    },
                                    expression: "form.middleCompanyName",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectMiddleCompany },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单总金额(含税)" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.totalOrderAmount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "totalOrderAmount", $$v)
                                  },
                                  expression: "form.totalOrderAmount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建人" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.createUser,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createUser", $$v)
                                  },
                                  expression: "form.createUser",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.createTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createTime", $$v)
                                  },
                                  expression: "form.createTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { "true-label": 1, "false-label": 0 },
                                  model: {
                                    value: _vm.form.isVatRetreat,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "isVatRetreat", $$v)
                                    },
                                    expression: "form.isVatRetreat",
                                  },
                                },
                                [_vm._v("退征即退")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.note,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "note", $$v)
                                  },
                                  expression: "form.note",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据日期", prop: "orderTime" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.form.orderTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "orderTime", $$v)
                                  },
                                  expression: "form.orderTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "来源订单",
                                prop: "sourceOrderSn",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    readonly: "",
                                    placeholder: "请点击图标选择",
                                  },
                                  model: {
                                    value: _vm.form.sourceOrderSn,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "sourceOrderSn", $$v)
                                    },
                                    expression: "form.sourceOrderSn",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectSourceOrder },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "ZP03投入总重量" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "审核后自动生成",
                                },
                                model: {
                                  value: _vm.form.sumWeight,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sumWeight", $$v)
                                  },
                                  expression: "form.sumWeight",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "跟单员", prop: "orderFollower" },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    readonly: "",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.form.orderFollower,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "orderFollower", $$v)
                                    },
                                    expression: "form.orderFollower",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectOrderFollower },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "附件信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c("FileUpload", {
                        attrs: {
                          "file-type": [
                            "png",
                            "jpg",
                            "jpeg",
                            "doc",
                            "xls",
                            "pdf",
                            "xlsx",
                            "docx",
                          ],
                          value: _vm.form.crmSalesOrdersAccessoryModels,
                          "show-delect":
                            _vm.form.status <= 1 || _vm.form.status == null,
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "crmSalesOrdersAccessoryModels",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "订单明细" } },
                [
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activePaneName,
                        callback: function ($$v) {
                          _vm.activePaneName = $$v
                        },
                        expression: "activePaneName",
                      },
                    },
                    [
                      _vm.form.salesCode === "ZOR2"
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "配件", name: "mountings" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "10px",
                                    display: "flex",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addSourceMountingsLine()
                                        },
                                      },
                                    },
                                    [_vm._v("来源订单明细")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addMountingsLine()
                                        },
                                      },
                                    },
                                    [_vm._v("新增")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addCommonsLine()
                                        },
                                      },
                                    },
                                    [_vm._v("新增通用物料")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delectMountingsLine()
                                        },
                                      },
                                    },
                                    [_vm._v("一键清空配件列表")]
                                  ),
                                  _c("excel-import", {
                                    attrs: {
                                      "is-download-template": false,
                                      "template-name":
                                        "CrmSalesLineDataImport.xlsx",
                                      url: "/crm/sales/line/excelImport",
                                      template: "CrmSalesLineDataImport.xlsx",
                                      "class-name": "CrmSalesLineDataImport",
                                      title: "导入",
                                    },
                                    on: { resdata: _vm.getMountingsLine },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleMountingsLineTemplateDownload()
                                        },
                                      },
                                    },
                                    [_vm._v("下载模版")]
                                  ),
                                ],
                                1
                              ),
                              !_vm.showObj.mountings
                                ? _c(
                                    "el-table",
                                    {
                                      ref: "mountingsTable",
                                      attrs: {
                                        height: "400px",
                                        data: _vm.form.mountingsList,
                                        border: "",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "index",
                                          label: "序号",
                                          width: "50",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "物料编码",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "productCode",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .productCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "productCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.productCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          380125132
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "物料名称",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "productName",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .productName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "productName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.productName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          885578700
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "订单数量",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop:
                                                          "mountingsList." +
                                                          scope.$index +
                                                          ".qty",
                                                        rules:
                                                          _vm.mountingsList.qty,
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          min: "0",
                                                          type: "number",
                                                        },
                                                        on: {
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.sumLordDutyPrice(
                                                              scope.row,
                                                              scope.$index,
                                                              "mountings"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: scope.row.qty,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "qty",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.qty",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          24814483
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "单位",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    { attrs: { prop: "unit" } },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value: scope.row.unit,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "unit",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.unit",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1526910572
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "是否需要采购",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "isPurchase",
                                                      },
                                                    },
                                                    [
                                                      _c("el-switch", {
                                                        attrs: {
                                                          disabled: true,
                                                          "active-text": "是",
                                                          "inactive-text": "否",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .isPurchase,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "isPurchase",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.isPurchase",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2062330270
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "拆解类型",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "separateType",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.setSeparateType(
                                                                scope.row
                                                                  .separateType,
                                                                scope.$index
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .separateType,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "separateType",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.separateType",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.separateTypeOption,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.code,
                                                                attrs: {
                                                                  label:
                                                                    item.name,
                                                                  value:
                                                                    item.code,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          339765351
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "含税单价",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop:
                                                          "mountingsList." +
                                                          scope.$index +
                                                          ".taxPrice",
                                                        rules:
                                                          _vm.mountingsList
                                                            .taxPrice,
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          min: "0",
                                                          type: "number",
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            return _vm.restrictNum(
                                                              scope.row
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.sumLordDutyPrice(
                                                              scope.row,
                                                              scope.$index,
                                                              "mountings"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.taxPrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "taxPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.taxPrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          933421357
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "终端含税价格",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "terminalPriceIncludingTax",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .terminalPriceIncludingTax,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "terminalPriceIncludingTax",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.terminalPriceIncludingTax",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1760073676
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "税率(%)",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "100",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "taxRatio",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "头部的销售组织带出",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.taxRatio,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "taxRatio",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.taxRatio",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2265190344
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "含税金额",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "lordDutyPrice",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .lordDutyPrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "lordDutyPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.lordDutyPrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4273844684
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "终端含税金额",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "terminalTaxIncludedAmount",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .terminalTaxIncludedAmount,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "terminalTaxIncludedAmount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.terminalTaxIncludedAmount",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          321830540
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "不含税金额",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "taxlessPrice",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .taxlessPrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "taxlessPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.taxlessPrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1904419756
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "批次号",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: { prop: "batch" },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.batch,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "batch",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.batch",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1095197900
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "OE",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: { prop: "oeCode" },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.oeCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "oeCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.oeCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          236699564
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "车辆ID",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: { prop: "carId" },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.carId,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "carId",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.carId",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2990388108
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "车牌",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: { prop: "carNo" },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.carNo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "carNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.carNo",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1819983564
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "品牌",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: { prop: "brand" },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.brand,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "brand",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.brand",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          839057932
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "车系",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: { prop: "series" },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.series,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "series",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.series",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4045277228
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "年款",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "100",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "modelYear",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.modelYear,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "modelYear",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.modelYear",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1129535820
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "发动机型号",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "engineModel",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .engineModel,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "engineModel",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.engineModel",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2941621452
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "变速箱型号",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "transmissionModel",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .transmissionModel,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "transmissionModel",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.transmissionModel",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3860506124
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "排量",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "100",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "displacement",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .displacement,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "displacement",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.displacement",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          140003564
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "说明",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    { attrs: { prop: "note" } },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                        },
                                                        model: {
                                                          value: scope.row.note,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "note",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.note",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3944887472
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "操作",
                                          fixed: "right",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleMountingsDelete(
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("删除")]
                                                  ),
                                                  scope.row.isPurchase
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "blueBtn",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.setPurchase(
                                                                scope.row,
                                                                scope.$index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("采购信息")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3059800715
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.salesCode === "ZOR1"
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "废料", name: "flotsam" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "10px",
                                    display: "flex",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addSourceFlotsamLine()
                                        },
                                      },
                                    },
                                    [_vm._v("来源订单明细")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addFlotsamLine()
                                        },
                                      },
                                    },
                                    [_vm._v("新增")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delectFlotsamLine()
                                        },
                                      },
                                    },
                                    [_vm._v("一键清空废料列表")]
                                  ),
                                ],
                                1
                              ),
                              !_vm.showObj.flotsam
                                ? _c(
                                    "el-table",
                                    {
                                      ref: "flotsamTable",
                                      attrs: {
                                        height: "400px",
                                        data: _vm.form.flotsamList,
                                        border: "",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "index",
                                          label: "序号",
                                          width: "50",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "物料编码",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "productCode",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .productCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "productCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.productCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          380125132
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "物料名称",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "200",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "productName",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .productName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "productName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.productName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          885578700
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "是否返还",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "isPawhetherToReturnrts",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .whetherToReturn,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "whetherToReturn",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.whetherToReturn",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.whetherToReturnOptions,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  label:
                                                                    item.label,
                                                                  value:
                                                                    item.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1403116531
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "订单数量",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop:
                                                          "flotsamList." +
                                                          scope.$index +
                                                          ".qty",
                                                        rules:
                                                          _vm.flotsamList.qty,
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          min: "0",
                                                          placeholder: "请输入",
                                                          type: "number",
                                                        },
                                                        on: {
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.sumLordDutyPrice(
                                                              scope.row,
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: scope.row.qty,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "qty",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.qty",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          962161313
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "单位",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    { attrs: { prop: "unit" } },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value: scope.row.unit,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "unit",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.unit",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1526910572
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "市场价格",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "referencePrice",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .referencePrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "referencePrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.referencePrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          614589652
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "含税单价",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop:
                                                          "flotsamList." +
                                                          scope.$index +
                                                          ".taxPrice",
                                                        rules:
                                                          _vm.flotsamList
                                                            .taxPrice,
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          type: "number",
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            return _vm.restrictNum(
                                                              scope.row
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.sumLordDutyPrice(
                                                              scope.row,
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.taxPrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "taxPrice",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.taxPrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2461392579
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "不含税单价",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "taxExclusiveUnitPrice",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .taxExclusiveUnitPrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "taxExclusiveUnitPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.taxExclusiveUnitPrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3041175180
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "终端含税价格",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "terminalPriceIncludingTax",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .terminalPriceIncludingTax,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "terminalPriceIncludingTax",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.terminalPriceIncludingTax",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1760073676
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "税率(%)",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "100",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "taxRatio",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "头部的销售组织带出",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.taxRatio,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "taxRatio",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.taxRatio",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2265190344
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "含税金额",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "lordDutyPrice",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .lordDutyPrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "lordDutyPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.lordDutyPrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4273844684
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "终端含税金额",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "terminalTaxIncludedAmount",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .terminalTaxIncludedAmount,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "terminalTaxIncludedAmount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.terminalTaxIncludedAmount",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          321830540
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "不含税金额",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "taxlessPrice",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                          placeholder:
                                                            "自动生成",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .taxlessPrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "taxlessPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.taxlessPrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1904419756
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "是否配件",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "isParts",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.isParts,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "isParts",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.isParts",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.isPartsOptions,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  label:
                                                                    item.label,
                                                                  value:
                                                                    item.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          861063059
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "说明",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    { attrs: { prop: "note" } },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                        },
                                                        model: {
                                                          value: scope.row.note,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "note",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.note",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3944887472
                                        ),
                                      }),
                                      false
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "扣杂金额",
                                              align: "left",
                                              "show-overflow-tooltip": "",
                                              width: "150",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            prop: "deductionAmount",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "请输入",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .deductionAmount,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "deductionAmount",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.deductionAmount",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1122118256
                                            ),
                                          })
                                        : _vm._e(),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "产值差异原因",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "lowPriceReason",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .lowPriceReason,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "lowPriceReason",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.lowPriceReason",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.lowPriceReasons,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  label:
                                                                    item.label,
                                                                  value:
                                                                    item.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          317220371
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "产值差异图片",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                          width: "260",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "fileList",
                                                      },
                                                    },
                                                    [
                                                      _c("UploadPicture", {
                                                        attrs: {
                                                          "file-type": [
                                                            "png",
                                                            "jpg",
                                                            "jpeg",
                                                          ],
                                                          "show-delect": true,
                                                          "reference-id":
                                                            scope.row.id,
                                                          "reference-table":
                                                            "crm_sales_orders_line",
                                                          attribute1:
                                                            "扣杂凭证",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2287511131
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "操作",
                                          fixed: "right",
                                          width: "100",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleFlotsamDelete(
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("删除")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1772478168
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "ZP03投入", name: "putIntoZP03" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addPutIntoZP03Line()
                                    },
                                  },
                                },
                                [_vm._v("新增")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectPutIntoZP03Line()
                                    },
                                  },
                                },
                                [_vm._v("一键清空散件列表")]
                              ),
                              _c("excel-import", {
                                attrs: {
                                  "is-download-template": false,
                                  "template-name":
                                    "CrmSalesLineDataImport.xlsx",
                                  url: "/crm/sales/line/excelImports",
                                  template: "CrmSalesLineDataImport.xlsx",
                                  "class-name": "CrmSalesLineDataImport",
                                  title: "导入",
                                },
                                on: { resdata: _vm.getPutIntoZP03Line },
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlePutIntoZP03LineTemplateDownload()
                                    },
                                  },
                                },
                                [_vm._v("下载模版")]
                              ),
                            ],
                            1
                          ),
                          !_vm.showObj.putIntoZP03
                            ? _c(
                                "el-table",
                                {
                                  ref: "putIntoZP03Table",
                                  attrs: {
                                    height: "400px",
                                    data: _vm.form.putIntoZP03,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: "序号",
                                      width: "50",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "物料编码",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "productCode",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.productCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "productCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.productCode",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      380125132
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "物料名称",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "productName",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.productName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "productName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.productName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      885578700
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "putIntoZP03." +
                                                      scope.$index +
                                                      ".qty",
                                                    rules: _vm.putIntoZP03.qty,
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      min: "0",
                                                      placeholder: "请输入",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value: scope.row.qty,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "qty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.qty",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3244163382
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "单位",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "unit" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.unit,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "unit",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.unit",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1526910572
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "单价",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "putIntoZP03." +
                                                      scope.$index +
                                                      ".price",
                                                    rules:
                                                      _vm.putIntoZP03.price,
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      min: "0",
                                                      placeholder: "请输入",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value: scope.row.price,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.price",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      476521959
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "税率(%)",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "taxRatio" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder:
                                                        "头部的销售组织带出",
                                                    },
                                                    model: {
                                                      value: scope.row.taxRatio,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "taxRatio",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.taxRatio",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2265190344
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "批次号",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "batch" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.batch,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "batch",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.batch",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1095197900
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "OE",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "oeCode" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.oeCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "oeCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.oeCode",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      236699564
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "重量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "weight" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.weight,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "weight",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.weight",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2652940268
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "车辆ID",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "carId" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.carId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "carId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.carId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2990388108
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "车牌",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "carNo" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.carNo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "carNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.carNo",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1819983564
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "品牌",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "brand" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.brand,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "brand",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.brand",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      839057932
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "车系",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "series" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.series,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "series",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.series",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4045277228
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "年款",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { prop: "modelYear" },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.modelYear,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "modelYear",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.modelYear",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1129535820
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "发动机型号",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "engineModel",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.engineModel,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "engineModel",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.engineModel",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2941621452
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "变速箱型号",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "transmissionModel",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .transmissionModel,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "transmissionModel",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.transmissionModel",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3860506124
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "排量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "displacement",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.displacement,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "displacement",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.displacement",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      140003564
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "说明",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "note" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                    },
                                                    model: {
                                                      value: scope.row.note,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "note",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.note",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3944887472
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "操作",
                                      fixed: "right",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handlePutIntoZP03Delete(
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1997616018
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "流程审批" } },
                [
                  _vm.form.status <= 1 || _vm.form.status == null
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "选择流程模板",
                                        prop: "flowPathTemplateId",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { placeholder: "选择模板" },
                                          on: {
                                            change: _vm.getFlowTempInfoList,
                                          },
                                          model: {
                                            value: _vm.form.flowPathTemplateId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "flowPathTemplateId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.flowPathTemplateId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.flowPathOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.templateName,
                                                value: item.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.flowPathNodePersonModels &&
                          _vm.form.flowPathNodePersonModels.length > 0
                            ? _c(
                                "el-table",
                                {
                                  ref: "elTable",
                                  staticStyle: { width: "50%" },
                                  attrs: {
                                    data: _vm.form.flowPathNodePersonModels,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "节点名称",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "nodePersonName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.nodePersonName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3691834225
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "审批人",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "auto",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "flowPathNodePersonModels." +
                                                      scope.$index +
                                                      ".nodePerson",
                                                    rules:
                                                      _vm
                                                        .flowPathNodePersonModels
                                                        .nodePerson,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        readonly: "",
                                                        placeholder:
                                                          "请点击图标选择",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.nodePerson,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "nodePerson",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.nodePerson",
                                                      },
                                                    },
                                                    [
                                                      scope.row.variable
                                                        ? _c("el-button", {
                                                            attrs: {
                                                              slot: "append",
                                                              icon: "el-icon-search",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectNodePerson(
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                            slot: "append",
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4032877737
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("Flow", {
                    ref: "flow",
                    attrs: {
                      disabled: _vm.type == "查看" || _vm.form.status > 2,
                      "custom-event": true,
                      "flow-id": _vm.form.flowId,
                    },
                    on: {
                      flowLoad: _vm.flowLoad,
                      complete: _vm.onComplete,
                      refresh: _vm.flowRefresh,
                      rejectTo: _vm.flowRejectTo,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { padding: "10px 20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: [3].includes(_vm.form.status),
                        loading: _vm.loading,
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form", false)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm.form.id && (_vm.form.status == 1 || !_vm.form.status)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveAndSubmit()
                            },
                          },
                        },
                        [_vm._v("提交")]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择审批人",
            visible: _vm.showObj.nodePerson,
            width: "30%",
            "before-close": _vm.nodePersonClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "nodePerson", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入审批人名称" },
                    model: {
                      value: _vm.condition.nodePerson.nodePerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.nodePerson, "nodePerson", $$v)
                      },
                      expression: "condition.nodePerson.nodePerson",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getNodePersonDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.nodePerson, border: "", height: "300" },
              on: { "selection-change": _vm.handleNodePersonSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "审批人",
                  align: "left",
                  prop: "nodePerson",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.nodePerson.total,
                  page: _vm.pagination.nodePerson.current,
                  limit: _vm.pagination.nodePerson.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.nodePerson,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.nodePerson, "size", $event)
                  },
                  pagination: _vm.getNodePersonDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.nodePersonClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.nodePersonConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择售达方",
            visible: _vm.showObj.soldToParty,
            width: "60%",
            "before-close": _vm.soldToPartyClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "soldToParty", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.condition.soldToParty.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.soldToParty,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.soldToParty.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getSoldToPartyDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              staticClass: "selectNone",
              attrs: {
                data: _vm.dialog.soldToParty,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleSoldToPartySelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户编码",
                  align: "left",
                  prop: "customerApplyNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.soldToParty.total,
                  page: _vm.pagination.soldToParty.current,
                  limit: _vm.pagination.soldToParty.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.soldToParty,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.soldToParty, "size", $event)
                  },
                  pagination: _vm.getSoldToPartyDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.soldToPartyClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.soldToPartyConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择送达方",
            visible: _vm.showObj.deliverySide,
            width: "60%",
            "before-close": _vm.deliverySideClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "deliverySide", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.condition.deliverySide.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.deliverySide,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.deliverySide.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getDeliverySideDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              staticClass: "selectNone",
              attrs: {
                data: _vm.dialog.deliverySide,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleDeliverySideSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户编码",
                  align: "left",
                  prop: "customerApplyNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.deliverySide.total,
                  page: _vm.pagination.deliverySide.current,
                  limit: _vm.pagination.deliverySide.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.deliverySide,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.deliverySide, "size", $event)
                  },
                  pagination: _vm.getDeliverySideDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.deliverySideClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.deliverySideConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择中间公司",
            visible: _vm.showObj.middleCompany,
            width: "60%",
            "before-close": _vm.middleCompanyClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "middleCompany", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入销售客户名称" },
                    model: {
                      value: _vm.condition.middleCompany.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.middleCompany,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.middleCompany.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getMiddleCompanyDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.middleCompany,
                border: "",
                height: "300",
              },
              on: {
                "selection-change": _vm.handleMiddleCompanySelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织编码",
                  align: "left",
                  prop: "salesOrganizationCode",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织",
                  align: "left",
                  prop: "salesOrganizationName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售客户",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购组织编码",
                  align: "left",
                  prop: "purchasingOrganizationCode",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购组织",
                  align: "left",
                  prop: "purchasingOrganizationName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购供应商",
                  align: "left",
                  prop: "supplierName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.middleCompany.total,
                  page: _vm.pagination.middleCompany.current,
                  limit: _vm.pagination.middleCompany.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.middleCompany,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.middleCompany,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getMiddleCompanyDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.middleCompanyClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.middleCompanyConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品配料",
            visible: _vm.showObj.mountings,
            width: "70%",
            "before-close": _vm.mountingsClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "mountings", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.mountings.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productName", $$v)
                      },
                      expression: "condition.mountings.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "精准编码查询" },
                    model: {
                      value: _vm.condition.mountings.preciseQuery,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "preciseQuery", $$v)
                      },
                      expression: "condition.mountings.preciseQuery",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        readonly: "",
                        placeholder: "点击图标批量编码查询",
                      },
                      model: {
                        value: _vm.condition.mountings.productCodes,
                        callback: function ($$v) {
                          _vm.$set(_vm.condition.mountings, "productCodes", $$v)
                        },
                        expression: "condition.mountings.productCodes",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.selectMountingsCodes },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.mountings.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productCode", $$v)
                      },
                      expression: "condition.mountings.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入OE" },
                    model: {
                      value: _vm.condition.mountings.oeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "oeCode", $$v)
                      },
                      expression: "condition.mountings.oeCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入车牌" },
                    model: {
                      value: _vm.condition.mountings.carNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "carNo", $$v)
                      },
                      expression: "condition.mountings.carNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getMountings("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.mountings,
                  expression: "loadingObj.mountings",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.mountings, border: "", height: "300" },
              on: { "selection-change": _vm.handleMountingsChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  prop: "oeCode",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "批次号",
                  align: "left",
                  prop: "batch",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  prop: "carId",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  width: "150",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  width: "150",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  width: "150",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.mountings.total,
                  page: _vm.pagination.mountings.current,
                  limit: _vm.pagination.mountings.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "size", $event)
                  },
                  pagination: _vm.getMountings,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.mountingsClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.mountingsConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品废料",
            visible: _vm.showObj.flotsam,
            width: "70%",
            "before-close": _vm.flotsamClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "flotsam", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.flotsam.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.flotsam, "productName", $$v)
                      },
                      expression: "condition.flotsam.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        readonly: "",
                        placeholder: "点击图标批量编码查询",
                      },
                      model: {
                        value: _vm.condition.flotsam.productCodes,
                        callback: function ($$v) {
                          _vm.$set(_vm.condition.flotsam, "productCodes", $$v)
                        },
                        expression: "condition.flotsam.productCodes",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.selectFlotsamCodes },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.flotsam.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.flotsam, "productCode", $$v)
                      },
                      expression: "condition.flotsam.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getFlotsam("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.flotsam,
                  expression: "loadingObj.flotsam",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.flotsam, border: "", height: "300" },
              on: { "selection-change": _vm.handleFlotsamChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.flotsam.total,
                  page: _vm.pagination.flotsam.current,
                  limit: _vm.pagination.flotsam.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.flotsam, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.flotsam, "size", $event)
                  },
                  pagination: _vm.getFlotsam,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.flotsamClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.flotsamConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "散件",
            visible: _vm.showObj.putIntoZP03,
            width: "70%",
            "before-close": _vm.putIntoZP03Close,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "putIntoZP03", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.putIntoZP03.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.putIntoZP03, "productName", $$v)
                      },
                      expression: "condition.putIntoZP03.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料编码" },
                    model: {
                      value: _vm.condition.putIntoZP03.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.putIntoZP03, "productCode", $$v)
                      },
                      expression: "condition.putIntoZP03.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getPutIntoZP03("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.putIntoZP03,
                  expression: "loadingObj.putIntoZP03",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.putIntoZP03,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handlePutIntoZP03Change },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  prop: "oeCode",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "批次号",
                  align: "left",
                  prop: "batch",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  prop: "carId",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  width: "150",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  width: "150",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "重量",
                  align: "left",
                  width: "150",
                  prop: "weight",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  width: "150",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.putIntoZP03.total,
                  page: _vm.pagination.putIntoZP03.current,
                  limit: _vm.pagination.putIntoZP03.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.putIntoZP03,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.putIntoZP03, "size", $event)
                  },
                  pagination: _vm.getPutIntoZP03,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.putIntoZP03Close } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.putIntoZP03Confirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "散件",
            visible: _vm.showObj.putIntoZP09,
            width: "70%",
            "before-close": _vm.putIntoZP09Close,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "putIntoZP09", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.putIntoZP09.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.putIntoZP09, "productName", $$v)
                      },
                      expression: "condition.putIntoZP09.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料编码" },
                    model: {
                      value: _vm.condition.putIntoZP09.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.putIntoZP09, "productCode", $$v)
                      },
                      expression: "condition.putIntoZP09.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getPutIntoZP09("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.putIntoZP09,
                  expression: "loadingObj.putIntoZP09",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.putIntoZP09,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handlePutIntoZP09Change },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  prop: "oeCode",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "批次号",
                  align: "left",
                  prop: "batch",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  prop: "carId",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  width: "150",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  width: "150",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  width: "150",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.putIntoZP09.total,
                  page: _vm.pagination.putIntoZP09.current,
                  limit: _vm.pagination.putIntoZP09.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.putIntoZP09,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.putIntoZP09, "size", $event)
                  },
                  pagination: _vm.getPutIntoZP09,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.putIntoZP09Close } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.putIntoZP09Confirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "批量编码查询(多个编码请用英文逗号分隔)",
            visible: _vm.mountingsCodes,
            width: "50%",
            "before-close": _vm.mountingsCodesClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.mountingsCodes = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "多个编码请用英文逗号分隔",
              rows: 15,
            },
            model: {
              value: _vm.condition.mountings.productCodes,
              callback: function ($$v) {
                _vm.$set(_vm.condition.mountings, "productCodes", $$v)
              },
              expression: "condition.mountings.productCodes",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.mountingsCodesClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.mountingsCodesClose },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "批量编码查询(多个编码请用英文逗号分隔)",
            visible: _vm.flotsamCodes,
            width: "50%",
            "before-close": _vm.flotsamCodesClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.flotsamCodes = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "多个编码请用英文逗号分隔",
              rows: 15,
            },
            model: {
              value: _vm.condition.flotsam.productCodes,
              callback: function ($$v) {
                _vm.$set(_vm.condition.flotsam, "productCodes", $$v)
              },
              expression: "condition.flotsam.productCodes",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.flotsamCodesClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.flotsamCodesClose },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择来源订单",
            visible: _vm.showObj.sourceOrder,
            width: "70%",
            "before-close": _vm.sourceOrderClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "sourceOrder", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择来源订单类型" },
                      model: {
                        value: _vm.condition.sourceOrder.sourceOrderType,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.condition.sourceOrder,
                            "sourceOrderType",
                            $$v
                          )
                        },
                        expression: "condition.sourceOrder.sourceOrderType",
                      },
                    },
                    _vm._l(_vm.sourceOrderTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.condition.sourceOrder.sourceOrderType === "2"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入车牌号" },
                        model: {
                          value: _vm.condition.sourceOrder.plateNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.condition.sourceOrder,
                              "plateNumber",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "condition.sourceOrder.plateNumber",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getSourceOrderDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.sourceOrder,
                  expression: "loadingObj.sourceOrder",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.sourceOrder,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleSourceOrderSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单编号",
                  align: "left",
                  prop: "sourceOrderSn",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm.condition.sourceOrder.sourceOrderType === "2"
                ? _c("el-table-column", {
                    attrs: {
                      label: "车牌",
                      align: "left",
                      prop: "plateNumber",
                      "show-overflow-tooltip": "",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: "订单名称",
                  align: "left",
                  prop: "sourceOrderName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单类型",
                  align: "left",
                  prop: "sourceOrderType",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("sourceOrderFilters")(
                                scope.row.sourceOrderType
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.sourceOrder.total,
                  page: _vm.pagination.sourceOrder.current,
                  limit: _vm.pagination.sourceOrder.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.sourceOrder,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.sourceOrder, "size", $event)
                  },
                  pagination: _vm.getSourceOrderDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.sourceOrderClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sourceOrderConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "来源订单配件明细",
            visible: _vm.showObj.sourceMountings,
            width: "70%",
            "before-close": _vm.sourceMountingsClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "sourceMountings", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.sourceMountings.productName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.sourceMountings,
                          "productName",
                          $$v
                        )
                      },
                      expression: "condition.sourceMountings.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "精准编码查询" },
                    model: {
                      value: _vm.condition.sourceMountings.preciseQuery,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.sourceMountings,
                          "preciseQuery",
                          $$v
                        )
                      },
                      expression: "condition.sourceMountings.preciseQuery",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.sourceMountings.productCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.sourceMountings,
                          "productCode",
                          $$v
                        )
                      },
                      expression: "condition.sourceMountings.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入OE" },
                    model: {
                      value: _vm.condition.sourceMountings.oeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.sourceMountings, "oeCode", $$v)
                      },
                      expression: "condition.sourceMountings.oeCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入车牌" },
                    model: {
                      value: _vm.condition.sourceMountings.carNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.sourceMountings, "carNo", $$v)
                      },
                      expression: "condition.sourceMountings.carNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getSourceMountings("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.sourceMountings,
                  expression: "loadingObj.sourceMountings",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.sourceMountings,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleSourceMountingsChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  prop: "oeCode",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "批次号",
                  align: "left",
                  prop: "batch",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  prop: "carId",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  width: "150",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  width: "150",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  width: "150",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.sourceMountings.total,
                  page: _vm.pagination.sourceMountings.current,
                  limit: _vm.pagination.sourceMountings.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.sourceMountings,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.sourceMountings,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getSourceMountings,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.sourceMountingsClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sourceMountingsConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "来源订单废料明细",
            visible: _vm.showObj.sourceFlotsam,
            width: "70%",
            "before-close": _vm.sourceFlotsamClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "sourceFlotsam", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.sourceFlotsam.productName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.sourceFlotsam,
                          "productName",
                          $$v
                        )
                      },
                      expression: "condition.sourceFlotsam.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.sourceFlotsam.productCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.sourceFlotsam,
                          "productCode",
                          $$v
                        )
                      },
                      expression: "condition.sourceFlotsam.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getSourceFlotsam("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.sourceFlotsam,
                  expression: "loadingObj.sourceFlotsam",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.sourceFlotsam,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleSourceFlotsamChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.sourceFlotsam.total,
                  page: _vm.pagination.sourceFlotsam.current,
                  limit: _vm.pagination.sourceFlotsam.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.sourceFlotsam,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.sourceFlotsam,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getSourceFlotsam,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.sourceFlotsamClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sourceFlotsamConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "采购订单信息",
            visible: _vm.showObj.purchase,
            width: "50%",
            "before-close": _vm.purchaseClose,
            "destroy-on-close": "",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "purchase", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "purchaseForm",
              attrs: {
                model: _vm.purchaseRow,
                disabled: _vm.type == "查看" || _vm.isRejectTo,
                rules: _vm.purchaseRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "采购订单号", prop: "poNo" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true, placeholder: "自动生成" },
                    model: {
                      value: _vm.purchaseRow.poNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "poNo", $$v)
                      },
                      expression: "purchaseRow.poNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "sap采购订单号", prop: "sapPoNo" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true, placeholder: "自动生成" },
                    model: {
                      value: _vm.purchaseRow.sapPoNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "sapPoNo", $$v)
                      },
                      expression: "purchaseRow.sapPoNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "供应商", prop: "supplierId" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.purchaseRow.supplierId,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseRow, "supplierId", $$v)
                        },
                        expression: "purchaseRow.supplierId",
                      },
                    },
                    _vm._l(_vm.supplierOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "采购组织",
                    prop: "purchasingOrganizationId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.purchaseRow.purchasingOrganizationId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.purchaseRow,
                            "purchasingOrganizationId",
                            $$v
                          )
                        },
                        expression: "purchaseRow.purchasingOrganizationId",
                      },
                    },
                    _vm._l(_vm.purchasingOrganizationOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购组", prop: "purchaseBasicsId" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.purchaseRow.purchaseBasicsId,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseRow, "purchaseBasicsId", $$v)
                        },
                        expression: "purchaseRow.purchaseBasicsId",
                      },
                    },
                    _vm._l(_vm.purchaseBasicsOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单价", prop: "unitPrice" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      placeholder: "请输入单价",
                      clearable: "",
                    },
                    model: {
                      value: _vm.purchaseRow.unitPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "unitPrice", _vm._n($$v))
                      },
                      expression: "purchaseRow.unitPrice",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "数量", prop: "qty" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      placeholder: "请输入数量",
                      clearable: "",
                    },
                    model: {
                      value: _vm.purchaseRow.qty,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "qty", _vm._n($$v))
                      },
                      expression: "purchaseRow.qty",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "进项税", prop: "taxCode" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.purchaseRow.taxCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseRow, "taxCode", $$v)
                        },
                        expression: "purchaseRow.taxCode",
                      },
                    },
                    _vm._l(_vm.inputTaxOptions, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label: item.name + "-" + item.code,
                          value: item.name,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.purchaseConfirm },
                    },
                    [_vm._v("确认")]
                  ),
                  _c("el-button", { on: { click: _vm.purchaseClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择公司",
            visible: _vm.showObj.company,
            width: "70%",
            "before-close": _vm.companyClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "company", $event)
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.company,
                  expression: "loadingObj.company",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.company, border: "", height: "300" },
              on: { "selection-change": _vm.handleCompanyChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "公司代码",
                  align: "left",
                  prop: "companyInfoNumber",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "公司描述",
                  align: "left",
                  prop: "companyInfoName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.company.total,
                  page: _vm.pagination.company.current,
                  limit: _vm.pagination.company.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.company, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.company, "size", $event)
                  },
                  pagination: _vm.getCompany,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.companyClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.companyConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择通用物料",
            visible: _vm.showObj.commons,
            width: "70%",
            "before-close": _vm.commonsClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "commons", $event)
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.commons,
                  expression: "loadingObj.commons",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.commons, border: "", height: "300" },
              on: { "selection-change": _vm.handleCommonsChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单位名称",
                  align: "left",
                  prop: "unit",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.commons.total,
                  page: _vm.pagination.commons.current,
                  limit: _vm.pagination.commons.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.commons, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.commons, "size", $event)
                  },
                  pagination: _vm.getCommons,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.commonsClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.commonsConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择跟单员",
            visible: _vm.showObj.orderFollower,
            width: "70%",
            "before-close": _vm.orderFollowerClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "orderFollower", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getOrderFollowerDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.orderFollower,
                  expression: "loadingObj.orderFollower",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.orderFollower,
                border: "",
                height: "300",
              },
              on: {
                "selection-change": _vm.handleOrderFollowerSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单名称",
                  align: "left",
                  prop: "name",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.orderFollower.total,
                  page: _vm.pagination.orderFollower.current,
                  limit: _vm.pagination.orderFollower.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.orderFollower,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.orderFollower,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getOrderFollowerDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.orderFollowerClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.orderFollowerConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }